







































































export default {
	name: 'Website',
	data: () => ({
		showMenu: false,
		links: [
			{ text: 'Home', to: 'https://rambox.app' },
			{ text: 'Features', to: 'https://rambox.app/features' },
			{ text: 'Apps', to: 'https://rambox.app/apps' },
			{ text: 'Pricing', to: 'https://rambox.app/pricing' },
			{ text: 'Learn', to: 'https://rambox.app/faqs' },
			{
				text: 'Learn',
				children: [
					{
						text: 'FAQs',
						to: 'https://rambox.app/faqs',
					},
					{
						text: 'Blog',
						href: 'https://rambox.app/blog',
					},
					{
						text: 'Help Desk',
						href: 'https://support.rambox.app/support/solutions',
					},
				],
			},
		],
	}),
	methods: {
		download() {
			window.open('https://rambox.app/download', '_self');
		},
		enterprise() {
			window.open(this.$withLocale('https://admin.rambox.app/create'), '_self');
		},
	},
	mounted() {},
};
